import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SelectStatementResult } from "src/app/models/select-statement-result.model";
import { BaseService } from "src/app/services/base.service";
import { QueryFilterParameter } from "src/app/widgets/filters/models/query-filter-parameter.model";

@Injectable({
    providedIn: "root",
})
export class ScenarioComparisonService {
    constructor(private _baseService: BaseService) { }

    public getScenarioComparisonData(selectStatementId: number, selectionSetId: number, filters: QueryFilterParameter[]): Observable<ScenarioComparisonResult> {
        let url = `ScenarioComparison/GetData?selectStatementId=${selectStatementId}&selectionSetId=${selectionSetId}`;

        return this._baseService.post(url, filters);
    }

    public getAllMetrics(): Observable<string[]> {
        let url = `ScenarioComparison/GetAllMetrics`;

        return this._baseService.get(url);
    }

    public getAllMetricDefinitions(): Observable<string[]> {
        let url = `ScenarioComparison/GetAllMetrics`;

        return this._baseService.get(url);
    }

    public getMetricDefinitionsByMetricId(metricId: number): Observable<MetricDefinition[]> {
        let url = `ScenarioComparison/GetMetricDefinitionsByMetricId?metricId=${metricId}`;

        return this._baseService.get(url);
    }

    public getMetricDefinitionsByMetricName(metricName: string): Observable<MetricDefinition[]> {
        let url = `ScenarioComparison/GetMetricDefinitionsByMetricName?metricName=${metricName}`;

        return this._baseService.get(url);
    }

    public getSelectStatementAndSelectionSetIdsByMetric(metricName: string): Observable<[number, number]> {
        let url = `ScenarioComparison/GetSelectStatementAndSelectionSetIdsByMetric?metricName=${metricName}`;

        return this._baseService.get(url);
    }

    public getFilterSelectStatementAndSelectionSetIdsByMetric(metricName: string): Observable<[number, number]> {
        let url = `ScenarioComparison/GetFilterSelectStatementAndSelectionSetIdsByMetric?metricName=${metricName}`;

        return this._baseService.get(url);
    }
}

export class ScenarioComparisonResult {
    scenarioData: SelectStatementResult;
    scenarioPercentageRelation: any;
}

export class MetricDefinition {
    keyFigure: string;
    weight: number;
    positiveIsGood: boolean;
}

export class WeightedProp {
    propName: string;
    weight: number;
    positiveIsGood: boolean;
}